<template>
  <v-card>
    <v-card-title>Settings: {{ event.name }}</v-card-title>
    <v-divider></v-divider>

    <v-card-subtitle>
      Invitation link:
      <a target="_blank" :href="'/event/' + event._id">{{ event._id }}</a>
    </v-card-subtitle>
    <v-card-text>
      <v-form>
        <v-switch v-model="event.active" label="Enable event"></v-switch>
        <v-switch
          v-model="event.allowGuests"
          label="Allow guests to register"
          :hint="
            `Enable if you would like to create a new user guest account when a user is not found.`
          "
        ></v-switch>
        <v-text-field
          v-model="event.name"
          label="Organization Name"
        ></v-text-field>
        <v-textarea
          outlined
          v-model="event.description"
          label="Description"
        ></v-textarea>

        <v-text-field
          v-model="event.fromEmail"
          label="Email from name"
        ></v-text-field>
        <DatePicker
          label="Start"
          :datetime="event.startDate"
          @input="event.startDate = $event"
        />
        <v-divider><hr /></v-divider><br />
        <v-select
          v-model="event.theme"
          @change="changeProfile"
          :items="colorList"
          label="Select a color theme"
        ></v-select>

        <v-file-input
          @change="processLogo"
          label="logo"
          :rules="[(v) => validateImage(v)]"
        ></v-file-input>
        <div v-if="event.logo">
          <img width="100px" :src="event.logo" />
          <v-btn class="ml-4 mb-6" icon @click="event.logo = null"
            ><v-icon>mdi-delete</v-icon></v-btn
          >
        </div>

        <br />
        <v-card-actions>
          <v-btn dark color="primary" @click="saveSettings">Save</v-btn>
        </v-card-actions>
        <v-divider></v-divider>

        <v-card flat>
          <v-card-text class="text-center">
            Archiving this event will not delete any data.
            <v-btn @click="archiveEvent" outlined small color="primary"
              >Archive</v-btn
            >
          </v-card-text>
        </v-card>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import DatePicker from '@/components/Widgets/DatePicker.vue';
import { mapState } from 'vuex';
//import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      loading: false,
      date: new Date().toISOString().substr(0, 10),
      colorList: [
        'amber',
        'blue',
        'lightBlue',
        'blueGrey',
        'brown',
        'cyan',
        'green',
        'lightGreen',
        'grey',
        'indigo',
        'lime',
        'orange',
        'deepOrange',
        'pink',
        'purple',
        'deepPurple',
        'red',
        'shades',
        'teal',
        'yellow'
      ]
    };
  },
  computed: {
    ...mapState({ event: (state) => state.events.event })
  },
  methods: {
    validateImage(input) {
      if (!input) return true;
      if (!input.type.match(/image\/(jpe?g|png)/)) {
        return 'Image type must be JPG or PNG';
      }
      if (Number(input.size) > 50000) {
        return 'Image file too large. Maximum 50k';
      }
      return true;
    },
    processLogo(file) {
      if (!file) {
        this.event.logo = '';
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.event.logo = reader.result;
      };
    },
    changeProfile(selected) {
      //this.$VuetifySwitchTheme(selected)
      console.log(selected);
    },
    saveSettings() {
      this.$store.dispatch('saveEvent', this.event);
    },
    archiveEvent() {
      if (confirm(`Are you sure you want to archive ${this.event._id}?`)) {
        return this.$store.dispatch('archiveEvent');
      }
    }
  }
};
</script>
